<!-- Menu for switching the UI language -->
<template>
  <v-menu offset-y left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="locale-switcher-btn"
        text
        min-width="0"
        class="tw-px-2 tw-font-medium"
        v-bind="attrs"
        v-on="on"
        :title="$t('header.language')"
      >
        {{ $i18n.locale.toUpperCase() }}
      </v-btn>
    </template>
    <v-list class="py-0" dense>
      <v-list-item
        v-for="locale in availableLocales"
        :key="locale.code"
        @click="setLocale(locale.code)"
      >
        <v-list-item-title
          :class="{ 'tw-font-medium tw-text-green': locale.code === $i18n.locale }"
        >
          {{ locale.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { availableLocales, setLocale } from "@/i18n"

export default {
  name: "LocaleSwitcher",

  data: () => ({
    availableLocales,
  }),

  methods: {
    setLocale,
  },
}
</script>
